// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"feca2ccb","637":"feca2ccb"}[chunkId] + ".chunk.css";
};